/* 通用登录函数库 */
import config from '@/config/config'
import store from '@/store/store'

/**
 * 登录
 * @export
 * @param {string} [backUrl=''] 登录回调地址
 * @param {string} [level='reg'] 登录等级，'reg': 注册等级，仅注册用户才能进入，否则拉起登录，'anon': 匿名等级，如果已登录则传入authToken，否则不传
 */
export function login(backUrl = `${config.siteRoot}/buyvip`, level = 'reg') {
  store.dispatch('clearUserinfo')
  backUrl = _backUrlFilter(backUrl)
  backUrl += (backUrl.indexOf('?') >= 0) ? '&tag=login' : '?tag=login'
  backUrl = encodeURIComponent(backUrl.replace(/&&/, '&'))
  if (store.getters.isIlisten) {
    // app内登录
    window.location.href = `/authInWebView?caller=${store.getters.ilistenCaller}&level=${level}&tag=login`
  } else {
    // web登录
    window.location.href = `${config.loginUrl}?caller=${store.getters.ilistenCaller}&back_url=${backUrl}`
  }
}

/**
 * 登出/退出登录
 * @export
 * @param {string} [backUrl=''] 退出登录后再次登录的回调地址
 */
export function logout(backUrl = '') {
  store.dispatch('clearUserinfo')
  backUrl = _backUrlFilter(backUrl)
  backUrl += (backUrl.indexOf('?') >= 0 ) ? '&tag=login' : '?tag=login'
  backUrl = encodeURIComponent(backUrl.replace(/&&/, '&'))
  window.location.href = `${config.logoutUrl}?caller=${store.getters.ilistenCaller}&back_url=${backUrl}`
}

function _backUrlFilter(backUrl) {
  // All cookies should be cleaned
  // IMPORTANT! If cookies were set with attributes, exact same attributes should be pass to Cookies.remove()
  let urlReg = /(authtoken=.*?&)|(\??authtoken=[^&]*)/i
  return backUrl.replace(urlReg, '', '$1')
}
